<template>
  <div v-html="contentRTE" />
</template>

<script lang="ts" setup>
import { magnoliaGetters } from '~/composables/getters';

defineComponent({ name: 'KikParagraph' });

const { $domain } = useNuxtApp();

interface Props {
  content?: string | undefined;
}

const props = withDefaults(defineProps<Props>(), {
  content: undefined,
});

const contentRTE = computed(() => magnoliaGetters.resolveRichTextContentAssetLinks(props?.content, $domain.cmsAssetDomainPath));
</script>
